import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const initials = (n) => (n || '??').slice(0, 2).toUpperCase();

const NAV = [
  { to: '/vault',     icon: '🔑', label: 'Passwords' },
  { to: '/groups',    icon: '🗂',  label: 'Groups' },
  { to: '/dashboard', icon: '📊', label: 'Dashboard' },
];
const ADMIN_NAV = [
  { to: '/users', icon: '👥', label: 'Users' },
  { to: '/logs',  icon: '📋', label: 'Audit Logs' },
];

export default function Shell() {
  const { user, logout, isAdmin } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast('👋 Signed out', 'success');
    navigate('/login');
  };

  return (
    <div className="shell">
      {/* ── Sidebar ── */}
      <aside style={{
        width: 228, flexShrink: 0,
        background: 'var(--s1)', borderRight: '1px solid var(--border)',
        display: 'flex', flexDirection: 'column',
        position: 'sticky', top: 0, height: '100vh', overflowY: 'auto',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '22px 18px 8px' }}>
          <div style={{
            width: 32, height: 32, borderRadius: 9,
            background: 'linear-gradient(135deg,var(--accent),var(--purple))',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
            boxShadow: '0 0 20px var(--aglow)',
          }}>🔐</div>
          <span style={{ fontSize: 16, fontWeight: 800 }}>
            Vault<span style={{ color: 'var(--accent)' }}>Guard</span>
          </span>
        </div>

        {/* Nav */}
        <div style={{ marginTop: 14 }}>
          <SbSection label="Vault" />
          {NAV.map(n => <SbItem key={n.to} {...n} />)}
          {isAdmin && (
            <>
              <SbSection label="Admin" />
              {ADMIN_NAV.map(n => <SbItem key={n.to} {...n} />)}
            </>
          )}
        </div>

        {/* User footer */}
        <div style={{ marginTop: 'auto', padding: '14px 18px', borderTop: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
            <div style={{
              width: 32, height: 32, borderRadius: '50%', flexShrink: 0,
              background: user?.color || 'var(--accent)', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 800, fontSize: 12,
            }}>{initials(user?.username)}</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 13 }}>{user?.username}</div>
              <div style={{ fontSize: 10, color: 'var(--sub)', textTransform: 'uppercase', letterSpacing: '.7px' }}>{user?.role}</div>
            </div>
          </div>
          <button
            onClick={handleLogout}
            style={{
              marginTop: 10, width: '100%', padding: '7px',
              background: 'var(--s3)', border: '1px solid var(--border2)',
              borderRadius: 'var(--r-sm)', color: 'var(--sub)',
              fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--font)',
              transition: 'color .15s',
            }}
            onMouseEnter={e => e.target.style.color = 'var(--red)'}
            onMouseLeave={e => e.target.style.color = 'var(--sub)'}
          >Sign out</button>
        </div>
      </aside>

      {/* ── Main ── */}
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}

function SbSection({ label }) {
  return (
    <div style={{
      fontSize: 10, fontWeight: 700, color: 'var(--sub)',
      textTransform: 'uppercase', letterSpacing: '1.2px',
      padding: '12px 18px 4px',
    }}>{label}</div>
  );
}

function SbItem({ to, icon, label }) {
  return (
    <NavLink to={to} style={({ isActive }) => ({
      display: 'flex', alignItems: 'center', gap: 9,
      padding: '9px 18px', cursor: 'pointer',
      fontSize: 13.5, fontWeight: 600, textDecoration: 'none',
      transition: 'all .14s', borderLeft: '2.5px solid transparent',
      color: isActive ? 'var(--accent)' : 'var(--sub)',
      background: isActive ? 'var(--adim)' : 'transparent',
      borderLeftColor: isActive ? 'var(--accent)' : 'transparent',
    })}>
      <span style={{ fontSize: 16, width: 20, textAlign: 'center' }}>{icon}</span>
      {label}
    </NavLink>
  );
}
